import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-category-upload-image',
  templateUrl: './category-upload-image.component.html',
  styleUrl: './category-upload-image.component.scss'
})
export class CategoryUploadImageComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;

  @Output() image = new EventEmitter<File>();

  // Trigger the hidden file input
  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  // Handle file selection and preview
  onFileSelected(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      this.image.emit(fileInput.files[0]);
    }
  }

}
